function n(n,r){if(null==n)return{};var i={};for(var e in n)if({}.hasOwnProperty.call(n,e)){if(r.indexOf(e)>=0)continue;i[e]=n[e]}return i}export{n as _};
//# sourceMappingURL=objectWithoutPropertiesLoose-4d70e5e3.js.map
